import {OrderService, MovieService, RegionService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {

    mixins: [MetaData],

    data() {
        return {
            order: null,
            movie: {},
            cinema: {},
            session: undefined,
            stepType: "donate",
            stepNames: [
                {
                    step: 1,
                    text: 'Choose Your Amount'
                },
                {
                    step: 2,
                    text: 'Confirm Your Details'
                },
                {
                    step: 3,
                    text: 'Make Donation'
                },
            ]
        }
    },

    computed: {

        step(){
            return parseInt(this.$route.path.split('/').pop())
        },

    },
    methods: {

    },
    created(){
        if(this.step < 1 || !this.step || this.step == NaN) {
            this.$router.push('/donate/1')
        }
        this.metaTitle = 'Corporate Social Responsibility | Donate Today'
        this.metaDescription = 'Through our Corporate Social Investment (CSI) initiatives, we aim to help youngsters in underprivileged communities by identifying and helping those with visual problems nationwide. Contribute to this cause and donate today.'
    },

    mounted() {
        window.scroll({top: 0, left: 0})
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/donate/donate.js